import React from 'react'
import AppUserDetailsContent from '../../../components/Dashboard/AppUsersListContent/View';
import { Link } from 'react-router-dom';

function AppUserDetails() {
    return (
        <>
          {/* Breadcrumb */}
          {/* <div className="breadcrumb-card">
            <h5>Users</h5>
    
            <ul className="breadcrumb">
              <li>
                <Link to="/dashboard/ecommerce/">
                  <i className="material-symbols-outlined">home</i>
                  Dashboard
                </Link>
              </li>
              <li>App Users</li>
              <li>App Users Details</li>
            </ul>
          </div> */}
           
          <AppUserDetailsContent />
        </>
    );
}

export default AppUserDetails;
